import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
export function FadeIn({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6,
    delay
  }} className={className} data-id="element-166">
      {children}
    </motion.div>;
}
export function CTAButton({
  className = '',
  href = 'https://vitalyreset.com/cart/50443897700598:1'
}: {
  className?: string;
  href?: string;
}) {
  const handleClick = () => {
    trackAddToCart();
  };
  return <motion.a href={href} onClick={handleClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`inline-block bg-coral text-white font-bold py-4 px-8 rounded-full shadow-lg hover:bg-opacity-90 transition-colors text-center text-lg md:text-xl ${className}`} data-id="element-167">
      ¡SÍ, QUIERO MI RESET METABÓLICO AHORA!
    </motion.a>;
}